<template>
  <order-tracking v-if="!!order && !!order.units" :items="tracking ? tracking.items : []" :total="tracking ? tracking.total : 0" :is-loading="isLoading" :requested-units="order.units.requested" :completed-units="order.units.completed"/>
  <order-customer-info v-if="!!order && order.end_customer" :order="order" />
  <!-- <order-Billing-info v-if="!!order" :order="order" /> -->
  <order-summary v-if="!!order" :order="order" />
</template>

<script>

  import OrderTracking from "./OrderTracking.vue";
  /* import OrderBillingInfo from "./OrderBillingInfo.vue"; */
  import OrderCustomerInfo from "./OrderCustormerInfo.vue";
  import OrderSummary from "./OrderSummary.vue";
  // import OrderShipmentInfo from "./OrderShipmentInfo.vue";

  export default {
    name: "OrderFooter",
    components: {
      OrderTracking,
      /* OrderBillingInfo, */
      OrderCustomerInfo,
      OrderSummary,
    },
    props: {
      order: {
        type: Object,
        default: () => {
          return {
            end_customer: null
          };
        }
      }
    },  
    computed: {
      tracking() {
        return this.$store.state.order.orderTracking.data;
      },
      isLoading() {
        return this.$store.state.order.orderTracking.isLoading;
      }
    },

  };

</script>